import { ParagraphText } from './ParagraphText.tsx';
import { ParagraphTitle } from './ParagraphTitle.tsx';

export interface ICoverParagraphViewItemProps {
  title: string | null | undefined;
  text: string | null | undefined;
}

export function CoverParagraphViewItem(props: ICoverParagraphViewItemProps) {
  const { title, text } = props;
  return (
    <div>
      <section>
        <ParagraphTitle title={title} />
        <ParagraphText text={text} />
      </section>
    </div>
  );
}
